import React from "react";

import "./AMMainPage/style.scss";

import { LandingRoutes } from "../../Routes";


const AMMainContainer =() => {

      const type = 1;
      console.log('not loaded');
      return ( <LandingRoutes /> );

}

export default AMMainContainer;

